import { FC } from "react";
import { useTranslation } from "react-i18next";

import { HorizontalLine, Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Subheading } from "capitalrx-components-2.0/lib/typography";

import { formatDollars } from "@/App/utils/utils";

import "./PaymentDetails.scss";

const TRANSLATION_PATH = "PRICING_DETAIL_PANELS.paymentDetails";

interface PaymentDetailsProps {
  readonly patientPayAmount: number;
  readonly planPayAmount: number;
}

export const PaymentDetails: FC<PaymentDetailsProps> = ({ patientPayAmount, planPayAmount }) => {
  const { t: translate } = useTranslation();
  const totalAmount = (patientPayAmount || 0) + (planPayAmount || 0);
  const formattedPatientPayAmount = formatDollars(patientPayAmount || "0");
  const formattedPlanPayAmount = formatDollars(planPayAmount || "0");
  const formattedTotalAmount = formatDollars(totalAmount);

  return (
    <Stack>
      <Heading>{translate(`${TRANSLATION_PATH}.paymentSummary`)}</Heading>
      <Panel className="member-portal-panel" appearance="primary">
        <Stack>
          <Shelf>
            <Body>{translate(`${TRANSLATION_PATH}.totalAmount`)}</Body>
            <Shelf.Spacer />
            <Body>{formattedTotalAmount}</Body>
          </Shelf>
          <Shelf>
            <Body>{translate(`${TRANSLATION_PATH}.planPays`)}</Body>
            <Shelf.Spacer />
            <Body>
              {formattedPlanPayAmount}
            </Body>
          </Shelf>
          <HorizontalLine />
          <Shelf>
            <Subheading>{translate(`${TRANSLATION_PATH}.memberPays`)}</Subheading>
            <Shelf.Spacer />
            <Subheading>{formattedPatientPayAmount}</Subheading>
          </Shelf>
        </Stack>
      </Panel>
    </Stack>
  );
};
